import { reducerWithInitialState } from "typescript-fsa-reducers";

import { bootstrapCompanyProjects, loadCompanyProjects } from "../actions";

export interface ProjectsState {
  projectIds: EntityId[];
  isLoaded: boolean;
}

const InitialState: ProjectsState = {
  projectIds: [],
  isLoaded: false,
};

const projectsReducer = reducerWithInitialState<ProjectsState>(InitialState)
  .case(bootstrapCompanyProjects, (state, { result }) => {
    return {
      ...state,
      projectIds: result.projects,
      isLoaded: true,
    };
  })
  .case(loadCompanyProjects.done, (state, { result: actionRes }) => {
    const { result } = actionRes;
    return {
      ...state,
      projectIds: result.projects,
      isLoaded: true,
    };
  });

export default projectsReducer;



// WEBPACK FOOTER //
// ./frontend/src/companies/reducers/projects.ts